import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
  },
  learnMoreButton: {
    textDecoration: "underline",
    color: `${theme?.palette?.primary?.main} !important`,
  },
  buttonClassName: {
    padding: "11px 16px",
  },
  recordFooterClassName: {
    justifyContent: "space-between",
  },
  endDate: {
    justifyContent: "flex-start",
  },
  statusFixedColumn: {
    // The table lib pins the last fixed column (Status) AND the Actions
    // cell both at right:0 — its +actions-width adjustment only runs for
    // primaryActions, not desktopCustomPrimaryAction — so the floating
    // Status (z-index 1/3) would paint over the ••• on scroll. Park Status
    // one actions-width left of the edge (80px mirrors
    // primaryColumnProps.width) so both float side by side. Inert when the
    // table isn't scrolled (sticky keeps its natural position).
    right: "80px !important",
  },
  listItem: {
    padding: "0 0 0 16px",
    "& li": {
      marginTop: "16px",
      color: theme?.palette?.basic?.black,
      opacity: 0.85,
    },
  },
  createOfferModal: {
    padding: ({ isDesktop }) => (isDesktop ? "25px" : "15px"),
  },
  modalPaperClassName: {
    width: ({ isDesktop }) => isDesktop && "50%",
    margin: ({ isDesktop }) => (isDesktop ? 0 : "16px"),
    maxWidth: "none",
  },
}));
